import { createStore } from 'vuex';
import storeOptions from 'web/store/storeOptions';

export default createStore(storeOptions);
